export default __webpack_public_path__ + "e95cb85e145ea4583fdf910107f46d5c.ico";